import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "mainWrap" }
const _hoisted_2 = { class: "cp-filter" }
const _hoisted_3 = { class: "cp-filter-breadcrumb" }
const _hoisted_4 = { class: "cp-filter-title" }
const _hoisted_5 = {
  key: 0,
  class: "count-badge dsize"
}

import { isMobile, isTablet } from 'mobile-device-detect';
import lodash from 'lodash';
import html2canvas from 'html2canvas';
import FiltersIcon from '@/assets/icons/FiltersIcon.vue';
import {
  Header,
  HeaderData,
  Footer,
  FooterData,
  Platmap,
  LotDetails,
  SidebarHomePlan,
  Sidebar,
  LotPosition,
  Alert,
  Amenity,
  LotCount,
  NeighborhoodInfo,
  LotDetail,
  NeighborhoodPlatMap,
  LotCountNeighborhood,
  NeighborhoodSoldDetails,
  CommunityQmiDetails,
  QmiDetails,
  planDetails,
  QmiDays,
  NeighborhoodPlanQmiCounts,
  NeighborhoodHomePlans,
  LotInfo,
  NeighboorhoodCoords,
  QmiJobStatus,
  CommunityFutureHomePlans,
  ComparedSvgFooterData,
  Lot,
} from './../../types';
import {
  HomeType,
  HomeTypeCode,
  ModalType,
  Settings,
  Status,
  UrlFilterList,
} from './../../constant';
import PlatmapHeader from '../AppHeader.vue';
import PlatToolbar from '../AppToolBar.vue';
import PlatFooter from '../AppFooter.vue';
import PlatMapMain from '../PlatMapMain.vue';
import PlatSidebar from '../SideBar.vue';
import AppHeaderCircle from '../AppHeaderCircle.vue';
import MobileFilterModal from '../modal/MobileFilterModal.vue';
import TownHomeLevel from '../TownHomeLevel.vue';
import LongArrowLeftIcon from '@/assets/icons/LongArrowLeftIcon.vue';
import ElevationModal from '../modal/ElevationModal.vue';
import Legend from '../Legend.vue';
import {
  apiFetchHeaderDetails,
  apiFetchFooterDetails,
  apiFetchHomePlans,
  apiFetchQmiHomePlans,
  apiFetchLotsJobStatus,
} from './../../api';
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  onMounted,
  watch,
  toRefs,
  inject,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import emitter from '@/mitt';
import { computeNeighborhoodSoldDetails } from '@/core/funcs';

// injector

export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapPage',
  props: {
    selectedNeighborhoodCenterLongitude: {},
    selectedNeighborhoodCenterLatitude: {},
    platmap: {},
    lotDetails: {},
    neighborhoodId: {},
    communityId: {},
    selectedLotId: {},
    selectedHomePlanIds: {},
    loading: { type: Boolean },
    siblingSelected: { type: Boolean },
    amenities: {},
    isKioskMode: { type: Boolean },
    neighborhoods: {},
    selectedNeighborhoodIds: {},
    communityName: {},
    areaName: {},
    areaId: {},
    futureHomePlans: {},
    selectedLotIdInfo: {},
    isFetchedData: { type: Boolean }
  },
  emits: [
  'setZoomLevelMapPage',
  'setHomeTypeCount',
  'showPlanFutureLotFlyout',
  'setLotId',
  'updateLotInfo',
  'setAllAmenities',
  'loadNeighborhood',
  'selectNeighborhood',
  'setNeighborhoodName',
  'setLegends',
  'setAmenities',
  'setUnderlay',
  'printPDF',
  'calculateContactInfoTopPosition',
  'handlePrintSelectionClick',
  'showLoader',
  'hideLoader',
  'handleCloseLotInfo',
  'closeAmenityInfo',
  'notFound',
  'openModal',
  'updateChatBotPosition',
  'setNeighborhoodAreaName',
  'setCommunityName',
  'setAminityId',
  'fetchPlatmap',
  'fetchPlatmapCoordinates',
  'setPrintModal',
  'clearSelectedNeighborhoods',
  'setselectQmiData',
  'closeLotInfo',
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));
const mode = inject('mode', ref(''));

const props = __props;
const {
  selectedNeighborhoodCenterLatitude,
  selectedNeighborhoodCenterLongitude,
  platmap,
  lotDetails,
  neighborhoodId,
  communityId,
  selectedLotId,
  selectedHomePlanIds,
  loading,
  siblingSelected,
  amenities,
  isKioskMode,
  neighborhoods,
  selectedNeighborhoodIds,
  communityName,
  areaName,
  areaId,
  futureHomePlans,
  selectedLotIdInfo,
  isFetchedData,
} = toRefs(props);
const emit = __emit;
const modal = ref<any>(null);
const refs = ref<any>(null);

const selectedHomePlanId = ref('');
const selectedLotStatus = ref('');
const selectedJobNum = ref('');
const zoomOutDisabled = ref(false);
const zoomInDisabled = ref(false);
const centerLatitude = ref(0);
const centerLongitude = ref(0);
const toolbar = ref(true);
const availableSites = ref(0);
const communityCode = ref('');
const showMobileFilters = ref(false);
const isMobilePriceApplied = ref(false);
const noPricePlanVisited = ref(false);
const planPriceExsist = ref(true);
const availableLots = ref(0);
const hasMobile = ref(!!(isMobile && !isTablet));
const onChangeNeighbourhoodCount = ref(0);
const totalMobileFilterApplied = ref(0);
const minPriceRangeMobileFilter = ref(0);
const maxPriceRangeMobileFilter = ref(0);
const showMinPriceRangeMobileFilter = ref(0);
const showMaxPriceRangeMobileFilter = ref(0);
const showPriceRangeMobileFilter = ref(false);
const changedMinValue = ref(Settings.MinValue);
const changedMaxValue = ref(Settings.MaxValue);
const initialHomePlanCount = ref(0);
const filterMaxPrice = ref(Settings.MaxValue);
const filterMinPrice = ref(Settings.MinValue);
const sortBy = ref('');
const enableMobileApply = ref(false);
const hoverNeighborZoomLevel = ref(0);
const isDisableHoverNeighbor = ref(false);
const activeLevel = ref('');

const filteredHomePlans = ref<any[]>([]);
const header = ref<Header>({ open: false, data: {} as HeaderData });
const footer = reactive<Footer>({ open: true, data: [] as FooterData[] });
const sidebar = reactive<Sidebar>({
  open: true,
  data: [] as SidebarHomePlan[],
});
const qmiDetails = ref<CommunityQmiDetails>({} as CommunityQmiDetails);
const listPlanId = ref<string[]>([]);
const soldPercentage = ref<NeighborhoodSoldDetails[]>([]);
const neighborhoodsPlanQmiCount = ref<NeighborhoodPlanQmiCounts[]>([]);
const listHomeTypeMobileFilter = ref<string[]>([]);
const listPlanNameMobileFilter = ref<string[]>([]);
const qmiFilterListMobileFilter = ref<QmiDays[]>([]);
const lotsCount = reactive<LotCount>({
  available: 0,
  model: 0,
  quickmovein: 0,
  sold: 0,
  reserved: 0,
});
const neighborhoodLotsCount = ref<LotCountNeighborhood[]>([]);
const listPlanNameId = ref<string[]>([]);
const homeTypeLists = ref(new Set<string>());
const communityHomePlans = ref<SidebarHomePlan[]>([]);
const neighborhoodHomePlans = ref<NeighborhoodHomePlans[]>([]);
const filterHomeTypeList = ref<string[]>([]);
const filterPlanNameList = ref<string[]>([]);
const qmiFilterList = ref<QmiDays[]>([]);
const notReservedPlan = ref(Array<string>([]));
const centerMap = ref<NeighboorhoodCoords>({} as NeighboorhoodCoords);
const planAttachedFutureLot = ref(new Set<string>());
const matchedSvgfooterData = ref<ComparedSvgFooterData[]>([]);

const levelSelector = ref<any>(null);
const mobileFilter = ref<any>(null);
const platMapMain = ref<InstanceType<typeof PlatMapMain>>();
const platMapToolbar = ref<any>(null);
const platMapSidebar = ref<any>(null);
const selectedLotIdInfoData = ref({} as Lot);
const showPlanModal = ref(false);
const selectedPlan = ref({} as any);

const router = useRouter();
const route = useRoute();

const isOpenElevationModal = computed(
  () => isSalesOrLandView.value && showPlanModal.value
);

const hasAvailableLots = computed(() => {
  if (selectedNeighborhoodIds.value.length) {
    const count = neighborhoodLotsCount.value.find(
      (n) => n.neighborhoodId === selectedNeighborhoodIds.value[0]
    )?.available;
    return !!count && count > 0;
  }
  let total = 0;
  for (const n of neighborhoodLotsCount.value) {
    if (n?.available) total += n.available;
  }
  return total > 0;
});

const openPlanDetails = (payload: { type: string; plan: any }) => {
  showPlanModal.value = true;
  selectedPlan.value = payload.plan;
};
const closePlanDetails = () => {
  showPlanModal.value = false;
  selectedPlan.value = {};
  // cleanHomeId();
  // emit('closeLotInfo');
};
const cleanHomeId = () => {
  selectedHomePlanId.value = '';
  selectedJobNum.value = '';
  closePlanDetails();
};

const loadLotInfo = (payload: {
  lotId: string;
  homeplanIds: string[];
  lotPosition: any;
  status: string;
}) => {
  selectedHomePlanId.value = '';
  selectedJobNum.value = '';
  selectedLotStatus.value = payload.status;

  if (isMobile && platmap.value.underlay_on) {
    sidebar.open = false;
  }
  emit('setLotId', payload);
};

const selectNeighborhood = (neighborhoodId: string) => {
  autoSelectLevel('');
  activeLevel.value = '';
  emit('selectNeighborhood', neighborhoodId);
};

const loadAminityInfo = (payload: { amenityId: string; lotPosition: any }) => {
  emit('closeLotInfo');
  if (isMobile) sidebar.open = false;

  emit('setAminityId', payload.amenityId, payload.lotPosition);
};

const clearSelectedNeighborhoods = () => {
  if (hasMobile.value) clearMobileFilters();

  emit('clearSelectedNeighborhoods');
};

const updateNotOnlyReservedPlan = (notReserved: Array<string>) => {
  notReservedPlan.value = notReserved;
  sidebar.data = sidebar.data.filter((plan) =>
    notReservedPlan.value.includes(plan.plan_id)
  );
};

watch(listPlanNameId, (newVal) => {
  if (newVal.length && !newVal.includes(selectedHomePlanId.value)) {
    selectedHomePlanId.value = '';
  }
});

watch(
  selectedLotIdInfo,
  (newValue, prevValue) => {
    if (Object.keys(newValue).length) {
      selectedLotIdInfoData.value = selectedLotIdInfo.value.lot;
    } else {
      selectedLotIdInfoData.value = {} as Lot;
    }
  },
  {
    deep: true,
  }
);

watch(
  () => sidebar.open,
  (isOpen) => {
    if (isOpen && isMobile) {
      if (!hasMobile.value && refs.value?.platMapMain && platMapMain.value) {
        platMapMain.value.closeMapInfoWindow();
      }
      emit('closeLotInfo');
      emit('closeAmenityInfo');
    }
  }
);

const showHomeLevel = computed(() => {
  const selectedHomeType =
    header.value?.data?.sibling?.filter(
      (n) => n.id === selectedNeighborhoodIds.value[0]
    )?.[0]?.home_type || '';
  return (
    (!selectedHomeType?.length ||
      HomeType.includes(selectedHomeType.toLowerCase())) &&
    actualLevels.value.length
  );
});

const selectedLevel = (level: string) => {
  activeLevel.value = level;
};

const autoSelectLevel = (level: string) => {
  if (activeLevel.value !== level) {
    levelSelector.value?.setActiveLevel(level);
  }
};

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  disableHover: boolean;
  mapCenter: NeighboorhoodCoords;
}) => {
  const { zoomLevel, disableHover, mapCenter } = payload;
  hoverNeighborZoomLevel.value = zoomLevel;
  isDisableHoverNeighbor.value = disableHover;
  centerMap.value = mapCenter;
};

const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => {
  const currentNeighborhoodLines = document.getElementById(
    `LINE-${payload.neighborhoodId}`
  )?.children;
  if (currentNeighborhoodLines) {
    Array.from(currentNeighborhoodLines).forEach((line) => {
      Array.from(line.children).forEach((element) => {
        (element as HTMLElement).style.display = payload.display;
      });
    });
  }
};

const hideSibling = () => {
  if (header.value?.data?.sibling?.length) {
    header.value.data.sibling.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element && !selectedNeighborhoodIds.value.length) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'none' });
      } else if (element && !selectedNeighborhoodIds.value.includes(item.id)) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'none' });
      } else if (element && selectedNeighborhoodIds.value.includes(item.id)) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'flex' });
      }
    });
  }
};

const updateFooterData = (newMatchedSvgfooterData: ComparedSvgFooterData[]) => {
  matchedSvgfooterData.value = newMatchedSvgfooterData;
};

const communityLotCount = () => {
  if (neighborhoods.value.length > 1) {
    availableSites.value = 0;
    availableLots.value = 0;
    neighborhoodLotsCount.value.forEach((n) => {
      const availableGroup =
        (n.available || 0) +
        (n.quickmovein || 0) +
        (n.qmi || 0) +
        (n.future || 0);

      availableLots.value += n.available || 0;
      availableSites.value += availableGroup;
    });
  } else {
    const n = neighborhoodLotsCount.value[0];
    if (!n) return;

    const availableGroup =
      (n.available || 0) +
      (n.quickmovein || 0) +
      (n.qmi || 0) +
      (n.future || 0);

    availableLots.value = n.available || 0;
    availableSites.value = availableGroup;
  }
};
watch([selectedNeighborhoodIds], (newVal, oldVal) => {
  countMobileFiltersApplied();
  routeUpdate(newVal, oldVal);
  assignHomePlans();
});

watch(
  [
    filterPlanNameList,
    filterMaxPrice,
    filterMinPrice,
    filterHomeTypeList,
    sortBy,
    qmiFilterList,
  ],
  (newValues, oldValues) => {
    routeUpdate(newValues as any, oldValues as any);
  },
  {
    deep: true,
  }
);

watch(communityId, (newVal, _) => {
  resetCommunityRelatedInfo();
  if (newVal && newVal !== communityCode.value) {
    communityCode.value = newVal;
    fetchHeader();
  }
  if (isMobile) {
    footer.open = false;
  }
});

watch(
  neighborhoods,
  () => {
    setInitialPlansCountData();
  },
  {
    deep: true,
  }
);

const resetCommunityRelatedInfo = () => {
  sidebar.data = [];
  communityHomePlans.value = [];
  neighborhoodHomePlans.value = [];
  qmiDetails.value = {} as any;
  filteredHomePlans.value = [];
  initialHomePlanCount.value = 0;
  showPlanModal.value = false;
};

onBeforeMount(() => {
  if (communityId.value) {
    fetchHeader();
    if (isMobile) {
      footer.open = false;
    }
  }
});

onMounted(() => {
  emitter.on('communityUpdated', resetCommunityRelatedInfo);
  emitter.on('fetchNeighborhood', fetchHeader);
  if (isMobile && !isTablet) {
    setHeaderHeight();
  }
});

const updateNewHomePlanCount = (planId: string) => {
  const planAttachedLotsStatus =
    platMapMain.value?.getplanAttachedLotsStatus(planId);
  if (
    planAttachedLotsStatus?.size === 1 &&
    planAttachedLotsStatus.values().next().value === Status.FUTURE_HOME
  ) {
    planAttachedFutureLot.value.add(planId);
  }
};

const setHeaderHeight = () => {
  const mobileHeader = document.querySelector('.cp-filter') as HTMLDivElement;
  if (!mobileHeader) return;
  const mobileHeaderHeight = mobileHeader.offsetHeight;
  (document.querySelector('#mainWrap') as HTMLDivElement).style.setProperty(
    '--cpFilterHeight',
    `${mobileHeaderHeight}px`
  );
};

const setFilterProperties = (payload: {
  listHomeType: string[];
  listPlanName: string[];
  maxPrice: number;
  minPrice: number;
}) => {
  filterHomeTypeList.value = payload.listHomeType;
  filterPlanNameList.value = payload.listPlanName;
  filterMaxPrice.value = payload.maxPrice;
  filterMinPrice.value = payload.minPrice;
};
const setSortProperties = (sort: string) => {
  sortBy.value = sort;
};

const setQmiFilterProperties = (qmiDays: QmiDays[]) => {
  qmiFilterList.value = qmiDays;
};

const backPageAccess = () => {
  if (window.history.length) {
    window.close();
  }
};

const setplanPriceExsist = (exists: boolean) => {
  planPriceExsist.value = exists;
};

const updateMobilefilterCount = () => {
  if (
    isMobilePriceApplied.value &&
    !conditionShowPriceRange.value &&
    !planPriceExsist.value
  ) {
    totalMobileFilterApplied.value += 1;
  }
};
// const clearMobileFilterNoHomePlan = () => {
//   if (selectedNeighborhoodIds.value.length) {
//     const currentNeighborhood = neighborhoodHomePlans.value.filter(
//       (element) => element.neighborhoodId === selectedNeighborhoodIds.value[0]
//     );
//     if (currentNeighborhood.length && !currentNeighborhood[0].homePlans.length) {
//       clearMobileFilters();
//     }
//   }
// };

const toggleHeader = () => {
  header.value.open = !header.value.open;
};

const routeUpdate = (newValue: any, oldValue: any) => {
  if (newValue !== oldValue && !isSalesOrLandView.value) {
    router.push({ query: createRoutePath() }).catch(() => {});
  }
};

const createRoutePath = () => {
  const newQuery: Record<string, any> = { ...route.query };

  if (selectedNeighborhoodIds.value.length) {
    const currentNeighborhoodData = neighborhoods.value.find(
      (neighborhood) =>
        neighborhood.neighborhood_code === selectedNeighborhoodIds.value[0]
    );
    newQuery[UrlFilterList.NEIGHBORHOOD] =
      currentNeighborhoodData?.neighborhood_name.toLowerCase() || '';
  } else {
    newQuery[UrlFilterList.NEIGHBORHOOD] = [];
  }

  newQuery[UrlFilterList.PLAN_NAME] = filterPlanNameList.value ?? [];
  newQuery[UrlFilterList.HOME_TYPE] = filterHomeTypeList.value ?? [];

  if (sortBy.value.length) {
    newQuery[UrlFilterList.SORT_BY] = sortBy.value.toString() ?? [];
  }

  newQuery[UrlFilterList.QMI_FILTER] =
    qmiFilterList.value.map((qmi) => qmi.value) ?? [];
  newQuery[UrlFilterList.MAX_PRICE] =
    filterMaxPrice.value && filterMaxPrice.value !== Settings.MaxValue
      ? filterMaxPrice.value.toString()
      : [];

  newQuery[UrlFilterList.MIN_PRICE] =
    filterMinPrice.value && filterMinPrice.value !== Settings.MinValue
      ? filterMinPrice.value.toString()
      : [];

  return newQuery;
};

const toggleToolbar = () => {
  toolbar.value = !toolbar.value;
};

const toggleFooter = () => {
  footer.open = !footer.open;
  if (hasMobile.value) {
    sidebar.open = !footer.open;
  }
  emit('updateChatBotPosition', footer.open);
};
const toggleSidebar = () => {
  sidebar.open = !sidebar.open;
};
const setHomePlanId = (payload: { planId: string; jobNum: string }) => {
  const { planId, jobNum } = payload;
  filteredHomePlans.value.forEach((element) => {
    if (
      (element.plan_id === planId && jobNum === '') ||
      element.job_number === jobNum
    ) {
      selectedHomePlanId.value = planId;
      selectedJobNum.value = jobNum;
    }
  });
  if (!isSalesOrLandView.value) emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const hideSidebar = () => {
  sidebar.open = false;
};
const hideHeader = () => {
  toolbar.value = false;
  header.value.open = false;
};
const hideFooter = () => {
  footer.open = false;
};
const showFooter = () => {
  footer.open = true;
};
const showSidebar = () => {
  sidebar.open = true;
};
const showHeader = () => {
  toolbar.value = true;
  header.value.open = true;

  const timer = setTimeout(() => {
    if (platMapToolbar.value) {
      platMapToolbar.value.calculateToolbarTopPosition();
    }
    clearTimeout(timer);
  }, 10);
};
const zoomIn = () => {
  platMapMain.value?.svgZoomIn();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const zoomOut = () => {
  platMapMain.value?.svgZoomOut();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const autoFit = () => {
  platMapMain.value?.svgAutoFit();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const setMapCenter = (x: number, y: number) => {
  platMapMain.value?.setMapCenterUsingPixel(x, y);
};
const handlePrintClick = () => {
  const sessionData = window.sessionStorage.getItem(Settings.SESSION_KEY);

  emit('closeLotInfo');
  emit('closeAmenityInfo');

  emit('handlePrintSelectionClick', {
    printOptionSelected: true,
    showHomeLevel: showHomeLevel.value,
    actualLevels: actualLevels.value,
    selectedLevel: activeLevel.value,
  });

  if (sessionData || isSalesOrLandView.value) {
    emit('openModal', ModalType.CROPPING_TOOL);
    emit('setPrintModal', true);
  } else {
    emit('openModal', ModalType.CONTACT_INFO);
  }
};
const handleVisitClick = () => {
  emit('closeLotInfo');

  emit('handlePrintSelectionClick', {
    printOptionSelected: false,
    showHomeLevel: showHomeLevel.value,
    actualLevels: actualLevels.value,
    selectedLevel: activeLevel.value,
  });
  emit('openModal', ModalType.CONTACT_INFO);
};

const setInitialPlansCountData = () => {
  neighborhoodsPlanQmiCount.value = [];
  neighborhoods.value.forEach((neighborhood) => {
    neighborhoodsPlanQmiCount.value.push({
      neighborhoodId: neighborhood.neighborhood_code,
      neighborhoodQmisCount: 0,
      neighborhoodPlansCount: 0,
    });
  });
};

const changeHomeType = () => {
  header.value.data.sibling.forEach((neighbor) => {
    if (Object.keys(HomeTypeCode).includes(neighbor.home_type)) {
      neighbor.home_type =
        HomeTypeCode[neighbor.home_type as keyof typeof HomeTypeCode];
    }
  });
};
const fetchHeader = async (hideErrorPage = false) => {
  try {
    emit('showLoader');
    neighborhoodsPlanQmiCount.value = [];
    setInitialPlansCountData();

    const neighborhoodId =
      selectedNeighborhoodIds.value[0] ??
      neighborhoods.value[0].neighborhood_code;
    const data = await apiFetchHeaderDetails(neighborhoodId);
    const { result } = data;

    header.value.data = result as HeaderData;
    communityCode.value = header.value.data.community_code;

    emit('setCommunityName', header.value.data.community_name);
    await emitter.emit('communitySelected', communityCode.value);
    changeHomeType();
    emit('setNeighborhoodAreaName', header.value.data.area_link_name);
    const neighborhoodCodes = header.value.data.sibling.map(
      (sibling) => sibling.id
    );

    await Promise.all([fetchHomePlans(neighborhoodCodes), fetchFooter()]);
    await emit('fetchPlatmap', {
      neighborhoodId,
      communityCode: communityCode.value,
      header: header.value.data,
    });
  } catch (error) {
    console.error('Error fetching header details:', error);
    emit('hideLoader');
    if (!hideErrorPage) {
      emit('notFound');
    }
  }
};

const resetHeaderData = () => {
  header.value = { open: false, data: {} as HeaderData };
};

const reorderLegendPositions = (legends: FooterData[]) => {
  // legends[2] = sold & legends[3] = reserved
  if (legends && legends.length > 3) {
    const swap = legends[2];
    legends[2] = legends[3];
    legends[3] = swap;
  }
  return legends;
};

const updateLegends = (legendArr: string[]) => {
  if (
    (!selectedNeighborhoodIds.value.length &&
      Object.keys(futureHomePlans.value).length) ||
    (selectedNeighborhoodIds.value[0] &&
      Object.keys(futureHomePlans.value).includes(
        selectedNeighborhoodIds.value[0]
      ))
  ) {
    legendArr.push(Status.FUTURE_HOME);
  }
};

const fetchFooter = async () => {
  try {
    const data = await apiFetchFooterDetails(communityCode.value, mode.value);
    let { result } = data;
    result = reorderLegendPositions(result);
    footer.data = result as FooterData[];

    if (result.length) {
      let legendArr: string[] = [];
      result.forEach((legend: FooterData) => legendArr.push(legend.status));
      updateLegends(legendArr);
      emit('setLegends', legendArr.toString());
    }
  } catch (error) {
    emit('setLegends', '');
    footer.data = [];
  }
};

const assignHomePlansNeighborhood = (data: SidebarHomePlan[]) => {
  neighborhoodHomePlans.value = [];
  const neighborhoodsWithHP: string[] = [];

  data.forEach((homePlan) => {
    if (neighborhoodsWithHP.includes(homePlan.neighborhood_code)) {
      const requiredNeighborhood = neighborhoodHomePlans.value.find(
        (neighborhood) =>
          neighborhood.neighborhoodId === homePlan.neighborhood_code
      );
      requiredNeighborhood?.homePlans.push(homePlan);
    } else {
      neighborhoodsWithHP.push(homePlan.neighborhood_code);
      neighborhoodHomePlans.value.push({
        neighborhoodId: homePlan.neighborhood_code,
        homePlans: [homePlan],
      });
    }
  });
};

const assignHomePlansCommunity = (data: SidebarHomePlan[]) => {
  communityHomePlans.value = [];

  for (const homePlan of data) {
    const existingPlan = communityHomePlans.value.find(
      (plan) => plan.plan_id === homePlan.plan_id
    );

    if (
      existingPlan &&
      homePlan.price_low_with_premium !== 0 &&
      (existingPlan.price_low_with_premium > homePlan.price_low_with_premium ||
        existingPlan.price_low_with_premium === 0)
    ) {
      // Remove old plan and push new one
      communityHomePlans.value.splice(
        communityHomePlans.value.indexOf(existingPlan),
        1
      );
      communityHomePlans.value.push(homePlan);
    } else if (!existingPlan) {
      communityHomePlans.value.push(homePlan);
    }
  }
};

const assignHomePlans = () => {
  initialHomePlanCount.value = 0;

  if (selectedNeighborhoodIds.value.length) {
    const selectedNeighborhoodHomePlan = neighborhoodHomePlans.value.find(
      (neighborhood) =>
        neighborhood.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    sidebar.data = selectedNeighborhoodHomePlan
      ? selectedNeighborhoodHomePlan.homePlans
      : [];
  } else {
    sidebar.data = communityHomePlans.value;
  }

  initialHomePlanCount.value += sidebar.data.length;

  if (selectedNeighborhoodIds.value.length) {
    const count =
      qmiDetails.value[selectedNeighborhoodIds.value[0]]?.length ?? 0;
    initialHomePlanCount.value += count;
  } else {
    for (const key of Object.keys(qmiDetails.value)) {
      initialHomePlanCount.value += qmiDetails.value[key].length;
    }
  }
};

const fetchHomePlans = async (neighborhoodCodes: string[]) => {
  try {
    const promises = neighborhoodCodes.map((neighborhoodCode) =>
      apiFetchHomePlans(neighborhoodCode, communityCode.value)
    );

    const responses = await Promise.all(
      promises.map((promise) => promise.catch((error) => error))
    );

    const data: SidebarHomePlan[] = [];

    responses.forEach((eachPromiseData, idx) => {
      if (eachPromiseData.result) {
        data.push(...(eachPromiseData.result.home_planes as SidebarHomePlan[]));
        setNeighborhoodPlansCount(
          neighborhoodCodes,
          eachPromiseData.result.home_planes,
          idx
        );
      } else {
        setNeighborhoodPlansCount(neighborhoodCodes, [], idx);
      }
    });

    assignHomePlansNeighborhood(data);
    assignHomePlansCommunity(data);

    qmiDetails.value = (await apiFetchQmiHomePlans(
      communityCode.value
    )) as CommunityQmiDetails;

    assignHomePlans();

    // Convert prices to integer
    for (const key of Object.keys(qmiDetails.value)) {
      for (const value of qmiDetails.value[key]) {
        value.price = parseInt(value.price);
        value.color = mode.value === 'customer' ? '#99b5c5' : '#9EB4C3';
      }
    }

    setNeighborhoodQmisCount();
  } catch (error) {
    sidebar.data = [];
  }
};

const setNeighborhoodPlansCount = (
  neighborhoodCodes: string[],
  neighborhoodPlansData: SidebarHomePlan[],
  idx: number
) => {
  const currentNeighborhoodId = neighborhoodCodes[idx];
  const neighborhoodCountData = neighborhoodsPlanQmiCount.value.find(
    (countData) => countData.neighborhoodId === currentNeighborhoodId
  );

  if (neighborhoodCountData) {
    neighborhoodCountData.neighborhoodPlansCount = neighborhoodPlansData.length;
  }
};

const setNeighborhoodQmisCount = () => {
  for (const [key, value] of Object.entries(qmiDetails.value)) {
    const neighborhoodCountData = neighborhoodsPlanQmiCount.value.find(
      (countData) => countData.neighborhoodId === key
    );
    if (neighborhoodCountData) {
      neighborhoodCountData.neighborhoodQmisCount = value.length;
    }
  }
};

const disableZoomIn = () => {
  zoomInDisabled.value = !zoomInDisabled.value;
};

const disableZoomOut = () => {
  zoomOutDisabled.value = !zoomOutDisabled.value;
};

const recalculateSidebarHeight = (height?: number) => {
  platMapSidebar.value?.calculateDynamicHeight(height);
};

const calculateSoldLotsPercentage = (
  lotsCountNeighborhood: LotCountNeighborhood[]
) => {
  neighborhoodLotsCount.value = lotsCountNeighborhood;
  communityLotCount();

  soldPercentage.value = [];

  // Sales/Land use the current sold-percentage definition; the customer plat
  // map keeps the legacy production definition (see computeNeighborhoodSoldDetails).
  const isSalesOrLandView = mode.value === 'sales' || mode.value === 'land';

  lotsCountNeighborhood.forEach((lotCount) => {
    soldPercentage.value.push(
      computeNeighborhoodSoldDetails(lotCount, isSalesOrLandView)
    );

    if (lotCount.neighborhoodId === selectedNeighborhoodIds.value[0]) {
      availableLots.value = lotCount.available;
      availableSites.value =
        (lotCount.available || 0) +
        (lotCount.quickmovein || 0) +
        (lotCount.qmi || 0) +
        (lotCount.future || 0);
    }
  });
};

const setPlanNameListId = (ids: string[]) => {
  listPlanId.value = ids.slice(0);
};

const updatefilteredHomePlans = (plans: any[]) => {
  filteredHomePlans.value = plans;
  onChangeNeighbourhoodCount.value =
    platMapMain.value?.countLotsFilterPlans(filteredHomePlans.value) ?? 0;

  // let isHomePlanAvailableLeftRail = false;
  // filteredHomePlans.value.forEach((element) => {
  //   if ((element.plan_id === selectedHomePlanId.value && selectedJobNum.value === "") ||
  //       (element.job_number === selectedJobNum.value)) {
  //     isHomePlanAvailableLeftRail = true;
  //     return false;
  //   }
  // });
  // if (!isHomePlanAvailableLeftRail) {
  //   selectedHomePlanId.value = "";
  //   selectedJobNum.value = "";
  // }
};

watch(
  [filteredHomePlans, () => platMapMain.value?.ready],
  ([plans, isReady]) => {
    if (isReady && platMapMain.value) {
      onChangeNeighbourhoodCount.value =
        platMapMain.value.countLotsFilterPlans(plans) ?? 0;
    }
  },
  { immediate: true }
);
const actualLevels = computed(() => {
  let levels: string[] = [];
  if (lotDetails.value.neighborhoods?.length) {
    lotDetails.value.neighborhoods.forEach((lotDetail) => {
      lotDetail.lots.forEach((lot) => {
        if (lot.level && !levels.includes(lot.level)) {
          levels.push(lot.level);
        }
      });
    });
  }
  levels = levels?.sort((a, b) => Number(b) - Number(a));
  return levels.length ? levels : [];
});
const conditionShowPriceRange = computed(() => {
  if (!initialHomePlanCount.value) return true;

  if (selectedNeighborhoodIds.value.length) {
    const currentSoldPercentage = soldPercentage.value.filter((element) =>
      selectedNeighborhoodIds.value.includes(element.neighborhoodId)
    );
    return currentSoldPercentage.length &&
      currentSoldPercentage[0].soldPercentage
      ? currentSoldPercentage[0].soldPercentage >= 100
      : true;
  } else {
    const currentSoldPercentage = soldPercentage.value.filter(
      (element) => element.soldPercentage < 100
    );
    return !currentSoldPercentage.length;
  }
});
const toggleMobileFilterModalVisibility = (show = true) => {
  showMobileFilters.value = show;
  showPriceRangeMobileFilter.value = !conditionShowPriceRange.value
    ? show
    : false;
};
const setPlanDetailsHometypeList = (payload: {
  communityHomePlans: SidebarHomePlan[];
  homeTypeList: Set<string>;
  minPrice: number;
  maxPrice: number;
}) => {
  const {
    communityHomePlans: plans,
    homeTypeList,
    minPrice,
    maxPrice,
  } = payload;
  communityHomePlans.value = plans;
  homeTypeLists.value = homeTypeList;
  minPriceRangeMobileFilter.value = showMinPriceRangeMobileFilter.value =
    minPrice;
  maxPriceRangeMobileFilter.value = showMaxPriceRangeMobileFilter.value =
    maxPrice;
};

const updatePriceRangeMobile = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  changedMinValue.value = payload.minValue;
  changedMaxValue.value = payload.maxValue;
  enableMobileApply.value =
    payload.minValue > minPriceRangeMobileFilter.value ||
    payload.maxValue < maxPriceRangeMobileFilter.value;
};

const applyMobilePriceFilter = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  updatePriceRangeMobile(payload);
  minMaxValuePriceRangeMobileFilter();
  showPriceRangeMobileFilter.value = true;
  totalMobileFilterApplied.value += 1;
  isMobilePriceApplied.value = true;
};
const minMaxValuePriceRangeMobileFilter = () => {
  let priceMinValueMobileFilter = Settings.MinValue;
  showMinPriceRangeMobileFilter.value = minPriceRangeMobileFilter.value;

  let priceMaxValueMobileFilter = Settings.MaxValue;
  showMaxPriceRangeMobileFilter.value = maxPriceRangeMobileFilter.value;

  if (
    changedMinValue.value > minPriceRangeMobileFilter.value ||
    changedMaxValue.value < maxPriceRangeMobileFilter.value
  ) {
    priceMinValueMobileFilter = showMinPriceRangeMobileFilter.value =
      changedMinValue.value;
    priceMaxValueMobileFilter = showMaxPriceRangeMobileFilter.value =
      changedMaxValue.value;
    isMobilePriceApplied.value = true;
  } else {
    isMobilePriceApplied.value = false;
  }

  return { min: priceMinValueMobileFilter, max: priceMaxValueMobileFilter };
};

const applyMobileFilters = (payload: {
  listPlanName: string[];
  listHomeType: string[];
  qmiFilterList: QmiDays[];
}) => {
  const { listHomeType, listPlanName, qmiFilterList } = payload;
  listHomeTypeMobileFilter.value = listHomeType;
  listPlanNameMobileFilter.value = listPlanName;
  qmiFilterListMobileFilter.value = qmiFilterList;

  const minMax = minMaxValuePriceRangeMobileFilter();

  countMobileFiltersApplied();

  platMapSidebar.value?.filterPlanNameHomeType({
    listHomeType,
    listPlanName,
    maxPrice: minMax.max,
    minPrice: minMax.min,
  });
  platMapSidebar.value?.setQmiDaysMobileFilter(qmiFilterList);
};
const clearMobileFilters = () => {
  changedMaxValue.value = showMaxPriceRangeMobileFilter.value =
    maxPriceRangeMobileFilter.value;
  changedMinValue.value = showMinPriceRangeMobileFilter.value =
    minPriceRangeMobileFilter.value;

  listHomeTypeMobileFilter.value = [];
  listPlanNameMobileFilter.value = [];
  qmiFilterListMobileFilter.value = [];
  isMobilePriceApplied.value = false;
  totalMobileFilterApplied.value = 0;

  platMapSidebar.value?.filterPlanNameHomeType({
    listHomeType: [],
    listPlanName: [],
    maxPrice: 0,
    minPrice: 0,
  });
  platMapSidebar.value?.setQmiDaysMobileFilter([]);
};

// Count applied mobile filters
const countMobileFiltersApplied = () => {
  totalMobileFilterApplied.value = 0;

  if (listHomeTypeMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;
  if (listPlanNameMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;
  if (qmiFilterListMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;

  updateMobilefilterCount(); // ensure this function is also refactored for Composition API
};

__expose({
  listPlanNameMobileFilter,
  qmiFilterListMobileFilter,
  filterPlanNameList,
  filterMaxPrice,
  filterMinPrice,
  toolbar,
  recalculateSidebarHeight,
  showHeader,
  showFooter,
  showSidebar,
  hideFooter,
  hideHeader,
  handlePrintClick,
  applyMobileFilters,
  setFilterProperties,
  setMapCenter,
  resetHeaderData,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (showMobileFilters.value)
        ? (_openBlock(), _createBlock(MobileFilterModal, {
            key: 0,
            ref_key: "mobileFilter",
            ref: mobileFilter,
            qmiDetails: qmiDetails.value,
            communityHomePlans: communityHomePlans.value,
            homeTypeList: homeTypeLists.value,
            listHomeTypeMobileFilter: listHomeTypeMobileFilter.value,
            listPlanNameMobileFilter: listPlanNameMobileFilter.value,
            qmiFilterListMobileFilter: qmiFilterListMobileFilter.value,
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            minPriceRangeMobileFilter: minPriceRangeMobileFilter.value,
            maxPriceRangeMobileFilter: maxPriceRangeMobileFilter.value,
            showMinPriceRangeMobileFilter: showMinPriceRangeMobileFilter.value,
            showMaxPriceRangeMobileFilter: showMaxPriceRangeMobileFilter.value,
            showPriceRangeMobileFilter: showPriceRangeMobileFilter.value,
            enableMobileApply: enableMobileApply.value,
            homeTypeCount: platMapSidebar.value.homeTypeCount,
            planPriceExsist: planPriceExsist.value,
            onToggleMobileFilterModalVisibility: toggleMobileFilterModalVisibility,
            onApplyMobileFilters: applyMobileFilters,
            onClearMobileFilters: clearMobileFilters,
            onUpdatePriceRangeMobile: updatePriceRangeMobile
          }, null, 8, ["qmiDetails", "communityHomePlans", "homeTypeList", "listHomeTypeMobileFilter", "listPlanNameMobileFilter", "qmiFilterListMobileFilter", "selectedNeighborhoodIds", "minPriceRangeMobileFilter", "maxPriceRangeMobileFilter", "showMinPriceRangeMobileFilter", "showMaxPriceRangeMobileFilter", "showPriceRangeMobileFilter", "enableMobileApply", "homeTypeCount", "planPriceExsist"]))
        : _createCommentVNode("", true),
      (!!_unref(platmap).url && !_unref(lodash).isEmpty(_unref(lotDetails)) && !_unref(loading))
        ? (_openBlock(), _createBlock(PlatMapMain, {
            key: 1,
            ref_key: "platMapMain",
            ref: platMapMain,
            levels: actualLevels.value,
            activeLevel: activeLevel.value,
            underlay: _unref(platmap).underlay_on,
            lots: _unref(lotDetails).neighborhoods,
            amenities: _unref(lotDetails).amenity,
            svg: _unref(platmap).svg_html,
            centerLat: _unref(platmap).center_latitude,
            centerLong: _unref(platmap).center_longitude,
            neighborhoodCenterLat: _unref(selectedNeighborhoodCenterLatitude),
            neighborhoodCenterLong: _unref(selectedNeighborhoodCenterLongitude),
            swCornerLong: _unref(platmap).sw_corner_longitude,
            swCornerLat: _unref(platmap).sw_corner_latitude,
            neCornerLong: _unref(platmap).ne_corner_longitude,
            neCornerLat: _unref(platmap).ne_corner_latitude,
            mapDefaultZoom: _unref(platmap).zoom_level,
            selectedHomePlanId: selectedHomePlanId.value,
            selectedJobNum: selectedJobNum.value,
            listPlanId: listPlanId.value,
            neighborhoods: _unref(neighborhoods),
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            neighborhoodId: _unref(neighborhoodId),
            communityId: _unref(communityId),
            isKioskMode: _unref(isKioskMode),
            listPlanNameId: listPlanNameId.value,
            futureHomePlans: _unref(futureHomePlans),
            homeplans: sidebar.data,
            hoverNeighborZoomLevel: hoverNeighborZoomLevel.value,
            isDisableHoverNeighbor: isDisableHoverNeighbor.value,
            centerMap: centerMap.value,
            qmiDetails: qmiDetails.value,
            onAutoSelectLevel: autoSelectLevel,
            onShowPlanFutureLotFlyout: _cache[0] || (_cache[0] = 
          (payload) => emit('showPlanFutureLotFlyout', payload)
        ),
            onHideSibling: hideSibling,
            onSetAmenities: _cache[1] || (_cache[1] = (payload) => emit('setAmenities', payload)),
            onHandleVisitClick: handleVisitClick,
            onHideHeader: hideHeader,
            onHideFooter: hideFooter,
            onShowHeader: showHeader,
            onShowFooter: showFooter,
            onShowSidebar: showSidebar,
            onHideSidebar: hideSidebar,
            onDisableZoomIn: disableZoomIn,
            onDisableZoomOut: disableZoomOut,
            onLoadLotInfo: loadLotInfo,
            onCleanHomeId: cleanHomeId,
            onLoadAminityInfo: loadAminityInfo,
            onCloseLotInfo: _cache[2] || (_cache[2] = ($event: any) => (emit('closeLotInfo'))),
            onCloseAmenityInfo: _cache[3] || (_cache[3] = ($event: any) => (emit('closeAmenityInfo'))),
            onCalculateContactInfoTopPosition: _cache[4] || (_cache[4] = ($event: any) => (
          emit('calculateContactInfoTopPosition')
        )),
            onCalculateSoldLotsPercentage: calculateSoldLotsPercentage,
            onSetZoomLevelMapPage: _cache[5] || (_cache[5] = (payload) => emit('setZoomLevelMapPage', payload)),
            onUpdateLotInfo: _cache[6] || (_cache[6] = (payload) => emit('updateLotInfo', payload)),
            onUpdateNotOnlyReservedPlan: updateNotOnlyReservedPlan,
            onSetselectQmiData: _cache[7] || (_cache[7] = (payload) => emit('setselectQmiData', payload)),
            onUpdateFooterData: updateFooterData
          }, null, 8, ["levels", "activeLevel", "underlay", "lots", "amenities", "svg", "centerLat", "centerLong", "neighborhoodCenterLat", "neighborhoodCenterLong", "swCornerLong", "swCornerLat", "neCornerLong", "neCornerLat", "mapDefaultZoom", "selectedHomePlanId", "selectedJobNum", "listPlanId", "neighborhoods", "selectedNeighborhoodIds", "neighborhoodId", "communityId", "isKioskMode", "listPlanNameId", "futureHomePlans", "homeplans", "hoverNeighborZoomLevel", "isDisableHoverNeighbor", "centerMap", "qmiDetails"]))
        : _createCommentVNode("", true),
      (!!_unref(platmap).url && !_unref(lodash).isEmpty(header.value.data) && !_unref(loading))
        ? (_openBlock(), _createBlock(PlatToolbar, {
            key: 2,
            ref_key: "platMapToolbar",
            ref: platMapToolbar,
            headerOpen: header.value.open,
            zoomOutDisabled: zoomOutDisabled.value,
            zoomInDisabled: zoomInDisabled.value,
            isKioskMode: _unref(isKioskMode),
            toolbar: toolbar.value,
            onZoomIn: zoomIn,
            onZoomOut: zoomOut,
            onAutoFit: autoFit,
            onHandlePrintClick: handlePrintClick,
            onCalculateContactInfoTopPosition: _cache[8] || (_cache[8] = ($event: any) => (
          emit('calculateContactInfoTopPosition')
        )),
            onToggleToolbar: toggleToolbar
          }, null, 8, ["headerOpen", "zoomOutDisabled", "zoomInDisabled", "isKioskMode", "toolbar"]))
        : _createCommentVNode("", true),
      (_unref(isSalesOrLandView))
        ? (_openBlock(), _createBlock(ElevationModal, {
            key: 3,
            areaId: _unref(areaId),
            showModal: showPlanModal.value,
            selectedPlan: selectedPlan.value,
            selectedLotInfo: selectedLotIdInfoData.value,
            hasAvailableLots: hasAvailableLots.value,
            onCloseModal: closePlanDetails
          }, null, 8, ["areaId", "showModal", "selectedPlan", "selectedLotInfo", "hasAvailableLots"]))
        : _createCommentVNode("", true),
      _createVNode(PlatSidebar, {
        ref_key: "platMapSidebar",
        ref: platMapSidebar,
        isOpenElevationModal: isOpenElevationModal.value,
        areaName: _unref(areaName),
        communityName: _unref(communityName),
        isFetchedData: _unref(isFetchedData),
        initialHomePlanCount: initialHomePlanCount.value,
        headerOpen: header.value.open,
        headerData: header.value.data,
        footerOpen: footer.open,
        sidebarOpen: sidebar.open,
        homeplans: sidebar.data,
        qmiDetails: qmiDetails.value,
        selectedJobNum: selectedJobNum.value,
        neighborhoods: _unref(neighborhoods),
        selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
        selectedHomePlanIds: _unref(selectedHomePlanIds),
        selectedHomePlanId: selectedHomePlanId.value,
        selectedLotStatus: selectedLotStatus.value,
        selectedLotId: _unref(selectedLotId),
        availableSites: onChangeNeighbourhoodCount.value,
        availableLots: availableLots.value,
        neighborhoodId: _unref(neighborhoodId),
        isKioskMode: _unref(isKioskMode),
        soldPercentage: soldPercentage.value,
        neighborhoodsPlanQmiCount: neighborhoodsPlanQmiCount.value,
        lotsCount: neighborhoodLotsCount.value,
        communityHomePlans: communityHomePlans.value,
        totalMobileFilterApplied: totalMobileFilterApplied.value,
        notReservedPlan: notReservedPlan.value,
        coordinates: _unref(platmap).neighborhoods,
        futureHomePlans: _unref(futureHomePlans),
        planAttachedFutureLot: planAttachedFutureLot.value,
        svg: _unref(platmap).svg_html,
        selectedLotIdInfo: selectedLotIdInfoData.value,
        onHideSibling: hideSibling,
        onSetFilterProperties: setFilterProperties,
        onSetSortProperties: setSortProperties,
        onSetQmiFilterProperties: setQmiFilterProperties,
        onToggleSidebar: toggleSidebar,
        onSelectNeighborhood: selectNeighborhood,
        onSetplanPriceExsist: setplanPriceExsist,
        onSetHomePlanId: setHomePlanId,
        onCloseLotInfo: _cache[9] || (_cache[9] = ($event: any) => (emit('closeLotInfo'))),
        onLoadNeighborhood: _cache[10] || (_cache[10] = (value) => emit('loadNeighborhood', value)),
        onSetPlanNameListId: setPlanNameListId,
        onClearSelectedNeighborhoods: clearSelectedNeighborhoods,
        onUpdatefilteredHomePlans: updatefilteredHomePlans,
        onSetPlanDetailsHometypeList: setPlanDetailsHometypeList,
        onApplyMobileFilters: applyMobileFilters,
        onApplyMobilePriceFilter: applyMobilePriceFilter,
        onSetHomeTypeCount: _cache[11] || (_cache[11] = (payload) => emit('setHomeTypeCount', payload)),
        onHighlightNeighborhood: highlightNeighborhood,
        onSethoverNeighborZoomLevel: sethoverNeighborZoomLevel,
        onCleanHomeId: cleanHomeId,
        onUpdateNewHomePlanCount: updateNewHomePlanCount,
        onOpenModal: openPlanDetails,
        onCloseModal: closePlanDetails
      }, null, 8, ["isOpenElevationModal", "areaName", "communityName", "isFetchedData", "initialHomePlanCount", "headerOpen", "headerData", "footerOpen", "sidebarOpen", "homeplans", "qmiDetails", "selectedJobNum", "neighborhoods", "selectedNeighborhoodIds", "selectedHomePlanIds", "selectedHomePlanId", "selectedLotStatus", "selectedLotId", "availableSites", "availableLots", "neighborhoodId", "isKioskMode", "soldPercentage", "neighborhoodsPlanQmiCount", "lotsCount", "communityHomePlans", "totalMobileFilterApplied", "notReservedPlan", "coordinates", "futureHomePlans", "planAttachedFutureLot", "svg", "selectedLotIdInfo"]),
      (showHomeLevel.value)
        ? (_openBlock(), _createBlock(TownHomeLevel, {
            key: 4,
            levels: actualLevels.value,
            class: _normalizeClass(_unref(isSalesOrLandView) ? 'sales-mode' : 'customer-mode'),
            onSelectedLevel: selectedLevel,
            ref_key: "levelSelector",
            ref: levelSelector
          }, null, 8, ["levels", "class"]))
        : _createCommentVNode("", true),
      (!!_unref(platmap).url && !_unref(isSalesOrLandView))
        ? (_openBlock(), _createBlock(PlatFooter, {
            key: 5,
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            open: footer.open,
            futureHomePlans: _unref(futureHomePlans),
            matchedSvgfooterData: matchedSvgfooterData.value,
            data: footer.data,
            amenities: _unref(amenities),
            lotsCount: neighborhoodLotsCount.value,
            onToggleFooter: toggleFooter,
            onRecalculateSidebarHeight: recalculateSidebarHeight,
            onSetLegends: _cache[12] || (_cache[12] = ($event: any) => (emit('setLegends')))
          }, null, 8, ["selectedNeighborhoodIds", "open", "futureHomePlans", "matchedSvgfooterData", "data", "amenities", "lotsCount"]))
        : _createCommentVNode("", true),
      (!_unref(loading) && _unref(isSalesOrLandView) && _unref(platmap).url)
        ? (_openBlock(), _createBlock(Legend, {
            key: 6,
            selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
            matchedSvgfooterData: matchedSvgfooterData.value,
            data: footer.data,
            amenities: _unref(amenities),
            lotsCount: neighborhoodLotsCount.value,
            onSetLegends: _cache[13] || (_cache[13] = ($event: any) => (emit('setLegends')))
          }, null, 8, ["selectedNeighborhoodIds", "matchedSvgfooterData", "data", "amenities", "lotsCount"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "arrow",
            onClick: backPageAccess
          }, [
            _createVNode(LongArrowLeftIcon)
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(header.value.data.community_name) + " Community", 1)
        ]),
        (totalMobileFilterApplied.value)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5, _toDisplayString(totalMobileFilterApplied.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([
            'cp-filter-filters',
            { disableFilter: !initialHomePlanCount.value },
          ]),
          onClick: _cache[14] || (_cache[14] = () => toggleMobileFilterModalVisibility())
        }, [
          _createVNode(FiltersIcon),
          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Filters", -1))
        ], 2)
      ])
    ])
  ]))
}
}

})